/**
 * Web-Techservices partner attribution.
 *
 * On any page load, captures ?ref=AFFCODE from the URL and stashes it in a
 * 90-day cookie named `wts_ref`. On signup completion, the cookie is read and
 * sent to the backend so the partner gets credited $100 by WTS.
 *
 * Why cookie not localStorage: cookies persist across subdomains (charity-
 * fundraiser.com → /signup-org), respect the 90-day window naturally, and
 * survive incognito-style soft cleans better than localStorage.
 */

const COOKIE_NAME = "wts_ref";
const TTL_DAYS = 90;

export function captureRefFromUrl() {
    try {
        const params = new URLSearchParams(window.location.search);
        const ref = (params.get("ref") || "").trim();
        if (!ref) return;
        // Sanitize: WTS affiliate codes are alphanumeric + dashes/underscores
        // up to ~64 chars. Reject anything that looks like an injection attempt.
        if (!/^[A-Za-z0-9_-]{2,64}$/.test(ref)) return;
        setRef(ref);
    } catch { /* SSR or no window — ignore */ }
}

export function setRef(code) {
    const expires = new Date(Date.now() + TTL_DAYS * 86400 * 1000).toUTCString();
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getRef() {
    try {
        const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : "";
    } catch {
        return "";
    }
}

export function clearRef() {
    document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}
